// Retrieves input data from a form and returns it as a JSON object:
function formToJSON(elements) {
  return [].reduce.call(
    elements,
    function (data, element) {
      data[element.name] = element.value;
      return data;
    },
    {}
  );
}

// Get Shopify Friendly URL String
function getUrlString(data) {
  var urlParameters = Object.entries(data)
    .map(function (e) {
      return e.join("=");
    })
    .join("&");
  return urlParameters;
}

const enquiryForm = document.querySelector("#enquiry_form");

enquiryForm.addEventListener("submit", (e) => {
  e.preventDefault();

  // Get values from first name and last name fields
  const firstName = enquiryForm.querySelector(
    'input[name="enquiry[first_name]"]'
  ).value;
  const lastName = enquiryForm.querySelector(
    'input[name="enquiry[last_name]"]'
  ).value;

  // Concatenate first and last names into a full name (FNAME)
  const mcFname = `${firstName} ${lastName}`;

  const mcEmail = enquiryForm.querySelector(
    'input[name="enquiry[email]"]'
  ).value;
  const mcPhone = enquiryForm.querySelector(
    'input[name="enquiry[phone]"]'
  ).value;
  // const mcFname = enquiryForm.querySelector('input[name="enquiry[name]"]').value;
  const mcMessage = enquiryForm.querySelector(
    'textarea[name="enquiry[body]"]'
  ).value;
  const mcProduct = enquiryForm.querySelector(
    'input[name="enquiry[product-name]"]'
  ).value;
  const mcCheck = enquiryForm.querySelector(
    'input[name="b_5fe3d406a03fdb8c30913fc25_648dd1ef22"]'
  ).value;

  const successMessages = document.querySelectorAll(".form_message_success");
  const failMessages = document.querySelectorAll(".form_message_fail");

  const endpoint = "https://hooks.zapier.com/hooks/catch/15239382/36r4rw3/";
  const shopifyEndpoint = "/contact#contact_form";
  const mailchimpEndpoint =
    "https://arlostone.us20.list-manage.com/subscribe/post?u=5fe3d406a03fdb8c30913fc25&amp;id=648dd1ef22&amp;f_id=004333e7f0";

  const inputs = enquiryForm.querySelectorAll("[name]");

  failMessages.forEach((message) => {
    message.classList.add("message_hidden");
  });
  successMessages.forEach((message) => {
    message.classList.add("message_hidden");
  });

  // Prepare the form data for Zapier
  const originalFormData = new FormData(enquiryForm);
  const formData = new FormData();

  // Loop through original FormData and selectively append to new FormData
  for (let [key, value] of originalFormData.entries()) {
    if (key !== "enquiry[first_name]" && key !== "enquiry[last_name]") {
      formData.append(key, value);
    }
  }

  formData.append("enquiry[name]", mcFname);
  // formData.append('enquiry[phone]', mcPhone);
  // formData.append('enquiry[body]', mcMessage);
  // formData.append('enquiry[product-name]', mcProduct);
  // formData.append('enquiry[email]', mcEmail);

  // Prepare the form data for Mailchimp
  const mcFormData = new FormData();
  mcFormData.append("EMAIL", mcEmail);
  mcFormData.append("PHONE", mcPhone);
  mcFormData.append("FNAME", mcFname);
  mcFormData.append("MESSAGE", mcMessage);
  mcFormData.append("PRODNAME", mcProduct);
  mcFormData.append("u", "5fe3d406a03fdb8c30913fc25");
  mcFormData.append("id", "648dd1ef22");
  mcFormData.append("f_id", "004333e7f0");
  mcFormData.append("b_5fe3d406a03fdb8c30913fc25_648dd1ef22", mcCheck);
  mcFormData.append("subscribe", "Subscribe");

  fetch(endpoint, {
    method: "POST",
    body: formData,
  })
    .then((res) => {
      if (!res.ok) {
        throw Error(
          "Couldn't submit form. Please try again later or contact us directly."
        );
      } else {
        successMessages.forEach((message) => {
          message.classList.remove("message_hidden");
        });
        enquiryForm.reset();
      }
    })
    .catch((err) => {
      failMessages.forEach((message) => {
        message.classList.remove("message_hidden");
      });
    });

  // send to Mailchimp
  fetch(mailchimpEndpoint, {
    method: "POST",
    body: mcFormData,
    mode: "no-cors",
  }).catch((err) => {
    console.log(err);
  });

  // send to Shopify
  fetch(shopifyEndpoint, {
    method: "POST",
    body: getUrlString(formToJSON(inputs)),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Accept: "text/html, */*; q=0.01",
      "X-Requested-With": "XMLHttpRequest",
    },
  }).catch((err) => {
    console.log(err);
  });
});
